import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const bubbleStyles = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-800",
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-800",
];

export default function CategoryStrip() {
  return (
    <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
      {categories.map((category, index) => (
        <li key={category.slug}>
          <Link
            to={`/${category.slug}`}
            className="group h-full flex flex-col p-5 rounded-lg bg-background-50 border border-background-200/80 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span
              className={`w-11 h-11 rounded-md flex items-center justify-center text-xl ${bubbleStyles[index % bubbleStyles.length]}`}
            >
              <i className={category.icon}></i>
            </span>
            <h3 className="mt-4 text-base text-foreground-950">{category.name}</h3>
            <p className="mt-2 text-sm text-foreground-500 leading-relaxed flex-1">{category.desc}</p>
            <span className="mt-4 flex items-center justify-between text-xs text-foreground-400">
              <span>{category.count} 条内容</span>
              <span className="w-4 h-4 flex items-center justify-center text-primary-500 group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-line"></i>
              </span>
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
}